const dataViewModeConfig = {
  research: {
    headerVariant: "research",
    headerTitle: "Data View",
    headerSubtitle: "Shared dataset browser for admin and researcher workflows",
    canEditRecords: false,
    showBulkBatchDownload: false,
    selectedRowsHelpText: "Download only the checked rows from the current page.",
    searchModeHelpText: "Export only the rows currently visible on screen.",
  },
  admin: {
    headerVariant: "admin",
    headerTitle: "Data View",
    headerSubtitle: "Shared dataset browser for admin and researcher workflows",
    canEditRecords: true,
    showBulkBatchDownload: true,
    selectedRowsHelpText: "Download will include only the checked rows from this page.",
    searchModeHelpText: "Export only the rows currently visible on screen.",
  },
};

export default dataViewModeConfig;
